const DIAS = [
  "Domingo",
  "Segunda-feira",
  "Terça-feira",
  "Quarta-feira",
  "Quinta-feira",
  "Sexta-feira",
  "Sábado",
];
const MESES = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

export function formatarDataHoraPT(dateLike) {
  const d = typeof dateLike === "string" ? new Date(dateLike) : dateLike;
  const dia = DIAS[d.getDay()];
  const mes = MESES[d.getMonth()];
  const hh = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");
  return `${dia}, ${d.getDate()} de ${mes} de ${d.getFullYear()}, às ${hh}:${mm}`;
}

export function formatarDataPT(dateLike) {
  const d = typeof dateLike === "string" ? new Date(dateLike) : dateLike;
  return `${DIAS[d.getDay()]}, ${d.getDate()} de ${MESES[d.getMonth()]} de ${d.getFullYear()}`;
}

export function combinarDataHora(date, hhmm) {
  const [h, m] = hhmm.split(":").map(Number);
  const dt = new Date(date);
  dt.setHours(h, m, 0, 0);
  return dt;
}

export function isoLocal(date) {
  // Format date as YYYY-MM-DD using local fields (avoids UTC drift)
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
